/**
 * Placeholder junk in fields that need no entry (DBS-262, Cycle 4 Q4.1.3).
 *
 * "N/A", "NONE", "-" and friends typed into an OPTIONAL field are never the applicant's real data and go to the DBS
 * as-is, so they are rejected with a message that says to leave the field blank. Required fields are deliberately out
 * of scope: a value like "UNKNOWN" in a town is wrong but the applicant still has to put something there, and
 * blocking would strand them.
 */

/** Tokens that only ever mean "nothing to enter" (compared after trim, upper-case and space-collapse) */
export const PLACEHOLDER_TOKENS = [
  'N/A', 'N.A', 'N.A.', 'N A', 'NA', 'NONE', 'NIL', 'NULL', 'NO', 'NOT APPLICABLE', 'NOT KNOWN', 'UNKNOWN', 'DONT KNOW', "DON'T KNOW",
  'X', 'XX', 'XXX', '-', '--', '.', '..', '...', '?', 'TBC', 'TBA', 'SAME', 'AS ABOVE', 'NOTHING',
]

/** Name fields use a shorter list: "NA" and "NO" are real names in some languages, so only unambiguous junk is refused */
export const NAME_PLACEHOLDER_TOKENS = PLACEHOLDER_TOKENS.filter(t => !['NA', 'NO'].includes(t))

const norm = (value: string | null | undefined): string => (value ?? '').trim().toUpperCase().replace(/\s+/g, ' ')

/** The placeholder a value is, or null when it looks like real data */
export const placeholderIn = (value: string | null | undefined, tokens: string[] = PLACEHOLDER_TOKENS): string | null => {
  const v = norm(value)
  return v.length > 0 && tokens.includes(v) ? v : null
}
